import * as apiLib from './api';

export const list = async payload => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/place-auth/list', data);
    if (result.resultFlag) {
      return result.placeAuthList;
    } else {
      throw Object.assign(new Error('placeAuth list error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const detail = async payload => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/place-auth/detail', data);
    if (result.resultFlag) {
      return result.placeAuthInfo;
    } else {
      throw Object.assign(new Error('placeAuth detail error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};
